import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";

function CommissionDetailHeader({
  header,
  listPath = "/commissions-invoices",
  actions = null,
}) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm sm:px-5">
      <nav className="mb-1 flex items-center gap-1.5 text-[12px] text-slate-400">
        <Link
          to={listPath}
          className="transition hover:text-[#007BFF]"
        >
          Commissions
        </Link>
        <FaChevronRight size={9} className="opacity-60" />
        <span className="font-medium text-slate-600">Detail</span>
      </nav>

      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="min-w-0">
          <h1 className="mb-0 text-xl font-bold tracking-tight text-[#35314d] sm:text-2xl">
            {header?.title || "Commission detail"}
          </h1>
          {header?.subtext ? (
            <p className="mb-0 mt-0.5 text-[12px] text-slate-500">
              {header.subtext}
            </p>
          ) : null}
        </div>
        <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
          {actions}
          {header?.badge ? (
            <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-semibold text-slate-600">
              {header.badge}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default CommissionDetailHeader;
